import {nanoid} from 'nanoid/non-secure';
import {BatchLogger} from 'src/utils/observability/batchLogger';
import {type ObservabilityConfig} from 'src/utils/observability/metrics';

type AnalyticsParams = Record<string, unknown>;

export class ObservabilityAnalytics {
  private batchLogger?: BatchLogger;

  constructor(private config: ObservabilityConfig) {
    if (!config) {
      logError(new Error('Observability config is required'));
    }
    try {
      // An error here should not prevent the application from running, so we catch it and log it
      this.batchLogger = new BatchLogger({
        clientId: config.service,
      });
    } catch (error) {
      logError(`Failed to initialize batch logger:`);
      logError(error);
    }
  }

  action(eventName: string, parameters?: AnalyticsParams): void {
    this.batchLogger?.pushEvent({
      event_name: eventName,
      event_id: nanoid(),
      created: Math.floor(Date.now() / 1000).toString(),
      project: this.config.project,
      ...parameters,
    });
  }
}

export function logError(error: unknown): void {
  if (error instanceof Error) {
    // eslint-disable-next-line no-console
    console.error(`ObservabilityAnalytics error: ${error.message}`);
  } else {
    // eslint-disable-next-line no-console
    console.error(`ObservabilityAnalytics error:`, error);
  }
}
